module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/village//house-game_xiaoxiaole.png?v=4f4bbc08";